import * as React from 'react';
import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { Label } from '../../typography';

type Props = StyledSystemProps & {
  bg?: string;
  name?: string;
  type?: string;
  color?: string;
  width?: string;
  height?: string;
  paddingLeft?: string;
  boxShadow?: string;
  placeholder?: string;
  showEyeIcon?: boolean;
  passwordVisible?: boolean;
  children?: React.ReactNode;
  onTogglePassword?: () => void;
  disabled?: boolean;
  borderRadius?: string | number;
  id?: string;
  onChange?: (e: any) => void;
  autoComplete?: string;
  value?: string;
  min?: number;
  max?: number;
  field: any;
  label: string;
};

const InputWrap = styled.div`
  flex: 1 0 48%;
  margin-bottom: 15px;
  margin-right: 20px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-sizing: border-box;
  @media screen and (min-width: 52em) {
    flex: 1 0 23%;
  }
`;

const Thumbnail = styled.img`
  height: 40px;
  width: 40px;
  min-width: 40px;
  min-height: 40px;
  margin-right: 10px;
`;

const AwsImage: React.FC<Props> = (props: Props) => {
  const { field: { value } } = props;
  console.log(props);
  return (
    <InputWrap>
      <Label>{props.label}</Label>
      {!!value && (
        <div style={{ display: 'flex', wordBreak: 'break-word', alignItems: 'center' }}>
          <Thumbnail src={value.thumbnail || value.original || value.scaled} />
          <a href={value.original} target="_blank">View</a>
        </div>
      )}
      {!value && <i>No link provided</i>}
    </InputWrap>
  );
};

export default AwsImage;

AwsImage.defaultProps = {
  bg: 'paleGrey',
  field: { value: '' },
  borderRadius: 4,
};



// WEBPACK FOOTER //
// ./src/components/formElements/AwsImage.tsx